// productData.js
import { Link } from 'react-router-dom';

export const productData = {
    "colby-blinds": {
        id: "colby-blinds",

        // Page Meta Fields
        META_PG_Title: 'Colby Blinds - designed to provide beauty and energy efficiency',
        META_PG_OG_Description: 'Colby / Honeycomb Blinds has unique light & privacy control combinations of light filtering & room darkening engineered for energy efficiency',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/colby-blinds`,
        OG_Title: 'Colby Blinds',

        name: "Colby Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-slider-1.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-slider-2.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-slider-3.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-slider-4.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-slider-5.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-1.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-2.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-3.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-4.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-5.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-6.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-7.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-8.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-9.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-10.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-11.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-12.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-13.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-14.webp'
            ],
            text: [
                <>
                    <p>
                        <b>Callistus Colby Blinds</b> are one of the most energy-efficient window solutions, designed to enhance beauty and insulation in both warm and cold climates. These blinds feature soft, seamless fabrics with crisp pleats that hold their shape, giving your windows a refined and long-lasting look. With the <b>Top-Down / Bottom-Up</b> option, you can open the shade from the top, bottom, or both, allowing complete control over light and privacy — ideal for those who prefer <b>TDBU cellular shades</b>.
                    </p>

                    <p>
                        The <b>advanced automation system</b> in Colby Blinds adds further convenience, making it easy to position the day or night section exactly where you want. Whether you prefer a cordless design or a motorized setup, the operation remains smooth and user-friendly — perfect for homes that value <b>cordless cellular shades</b> or <b>cordless cellular blinds</b>.
                    </p>

                    <p>
                        <b>Colby Blinds</b> are popularly known as <b>honeycomb blinds</b> because of their unique cell structure, which helps trap air and improve insulation. Many customers also refer to them as <b>honeycomb blinds for windows</b>, <b>honeycomb window shades</b>, or <b>honeycomb blind</b> options. Their cellular design makes them equally recognized as <b>cellular shades</b>, <b>cellular blinds for windows</b>, <b>cellular window shades</b>, and <b>cellular blind</b> styles. Some even know them by premium names like <b>Duette blind</b>. The structure of <b>honeycomb cellular</b> fabrics ensures thermal comfort, while options like <b>blackout honeycomb blinds</b> provide superior light blocking.
                    </p>

                    <p>
                        These blinds come in sheer, light-filtering, room-darkening, and blackout fabrics, giving you the flexibility to choose the perfect level of privacy and light control. Whether you select <b>honeycomb cell blinds</b>, <b>cordless cellular blind</b> models, or standard <b>cellular shades and blinds</b>, every option maintains a clean and elegant look.
                    </p>

                    <p>
                        A wide palette of <b>28 fabrics</b>, elegant <b>colours</b>, and three transparency levels ensures these shades suit every interior style. The consistent pleat pattern adds a uniform, modern finish to any window. You can even choose the <b>same colour</b> across all transparency levels — ideal when each room needs a different amount of natural light without changing the overall aesthetic.
                    </p>

                    <p>
                        <b>Callistus Colby Blinds</b> bring together style, comfort, and smart technology, making them one of the most preferred choices among premium <b>honeycomb shades</b> and <b>cellular window blinds cordless</b> solutions.
                    </p>

                   
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        <b>Most energy efficient blinds</b> specifically engineered to provide beauty and energy efficiency in both cold and warm climates. <b>Callistus Colby blind</b> combines soft, seamless fabrics with crisp even pleats that hold their shape indefinitely. Choose <b>Top-down / Bottom-up</b> and open your shades from the top, bottom, or both.
                    </p>
                    <p>
                        <b>Advanced Automation System</b> in Colby Blinds where you can get benefit to operate Day or night section at any position.
                    </p>
                    <p>
                        <b>Callistus Colby blinds,</b> also known as Honeycomb Blinds, Cellular Blinds or Pleated Blinds come with unique light & privacy control <b>combinations</b> including sheer, light-filtering, room darkening, and blackout fabrics to provide you with various levels of privacy, light control and luxury.
                    </p>
                    <p>
                        <b>Callistus Colby blinds</b> are available in a wide assortment of 28 beautiful fabrics, rich structures and colours in three transparencies. They give a beautiful pleat pattern to your windows.
                    </p>
                    <p>
                        <b>Callistus Colby blind</b> fabric allows you to have the same colour in all three transparencies – depending on the level of privacy that you desire and the amount of light you want; you can choose different transparency in every room.
                    </p>
                   
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Sheer, Translucent & Blackout' },
                { label: 'Width (in mm)', value: '300 to 3000' },
                { label: 'Drop (in mm)', value: '300 to 5000' }
            ],
           // video: "https://www.youtube.com/embed/-U1mVUFPRPI?si=Kdc_C7cVq3K2jDaN",
           video: "https://www.youtube.com/embed/RjKXvRbFzcA?si=8Pb5SCtQTy3wlkAN",
           videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Colby Blinds",
            systems: [
                {
                    title: 'Clutch System',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/clutch-system-e1589892283945.webp',
                    description:
                        <>
                            <b>Callistus clutch system</b> for Colby blinds uses a retractable cord to raise and lower your blind while maintaining a constant cord length. There are no long, dangling cords to detract from the appearance of your window treatment. Ideal for child and pet safety.
                        </>
                },
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/manual-e1589892658172.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.
                        </>
                },
                {
                    title: 'Top-Down / Bottom-Up',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/top-Down-e1589892128193.webp',
                    description:
                        <>
                            Callistus Colby blind Top-Down/Bottom-Up offers you the ability to operate window blind from “top to down or from “bottom to up” to meet all your privacy needs while still giving you access to natural light.<br /><Link to="/top-down-bottom-up">Learn More</Link>
                        </>
                },
                {
                    title: 'Day & Night',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/Day-Night-e1589892712523.webp',
                    description:
                        <>
                            Day & Night operating system offers maximum light control by using two separate fabric panels to achieve a day/night level of convenience, providing limitless options for privacy and light control. Day & Night Operating system is available in the following combinations : <br /> 1) Visible- Translucent <br /> 2) Visible – Dimout <br /> 3) Translucent – Dimout <br /><Link to="/colby-blinds-day-and-night">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/Remote-e1589892304795.webp',
                    description:
                        <>
                            The Remote Control allows you to pre-set and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall.<br /><Link to="/colby-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            <b>Callistus Automation blinds</b> can be operated by using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                }
            ]
        },
        solutions: {
            text: [
                <>
                    <p>
                        Most of the heat lost or gained is through the windows, even when double glazed. Callistus Colby blinds offer an amazing solution for the same. Colby blinds have a layer of silver foil inside which makes them energy-saving window coverings that retain the internal temperature, adding substantial beauty to the interior simultaneously. Moreover, they noticeably improve the acoustics in the room.
                    </p>
                    <p>
                        <b>Advanced Automation System</b> in Colby Blinds where you can get benefit to operate Day or night section at any position.
                    </p>
                    <p>
                        Callistus Colby blinds come in various combinations which are mentioned below. These combinations serve all the demands with regard to Light Control or Privacy
                    </p>
                </>
            ],
            combinations: [
                {
                    title: 'Translucent & Blackout',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/BT.webp',
                    description: 'This is a combination of Dimout and Translucent fabrics, wherein one can maintain constant natural light or can darken the room completely as per need.'
                },
                {
                    title: 'Visible & Blackout',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/SB.webp',
                    description: 'If enjoying natural light while maintaining privacy is what you are looking for, then the combination of Visible and Translucent is the answer to that. Visible fabric illuminates the room with natural light, and Translucent fabric takes care of privacy while diffusing the light softly. Want to see through the blind while it is still unwound? Visible is the answer to the requirement. With Visible – Dimout combination, you can enjoy an almost clear view of outside and reasonably protect yourself from the direct sunlight. The Blackout fabric, on the other hand, facilitates light blockage completely or to the extent needed.'
                },
                {
                    title: 'Visible & Translucent',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/ST.webp',
                    description: 'If enjoying natural light while maintaining privacy is what you are looking for, then the combination of Visible and Translucent is the answer to that. Visible fabric illuminates the room with natural light, and Translucent fabric takes care of privacy while diffusing the light softly.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/ColbyBlindsImages/9.-1954-ckb.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/8.-1924-cmt.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/7.-1953-ckb.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/6.-1952-ckb.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/5.-1923-cmt.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/4.-1955-ckb.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/3.-1926-cmt.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/2.-1922-cmt.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/1.-1951-ckb.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/colby-blinds/colby-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "sierra-blinds": {
        id: "sierra-blinds",

        // Page Meta Fields
        META_PG_Title: 'Sierra Blinds - A brilliant way to dress up your windows!',
        META_PG_OG_Description: 'Sierra Blinds protecting you from UV Rays, combines practical qualities of slats with warmth & intimacy of curtains in a truly elegant manner',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/sierra-blinds`,
        OG_Title: 'Sierra Blinds',

        name: "Sierra Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-slider-1.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-slider-2.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-slider-3.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-insp-1.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-insp-2.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-insp-3.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-insp-4.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-insp-5.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-insp-6.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-insp-7.webp',
            ],
            text: [
                <>
                    <p>A brilliant new way to dress up your windows.</p>

                    <p>Callistus Sierra blind is a way of decorating your home that combines the practical qualities of slats with the warmth and intimacy of the curtains in a truly elegant manner.</p>

                    <p>Not only do they look great in the home but Sierra blinds are perfect for both domestic and commercial environments.</p>

                    <p>Their exclusive elegance is designed to improve the appearance of your interior and to provide a touch of style. These type of blinds integrate well with both – modern interiors as well as classical designs, because of the way they harmoniously combine practical attributes with distinctive allure.</p>

                    <p>If you’re looking to create an instant impact in your home with something a little different, then Sierra blinds would be a perfect choice. Sierra blinds really come into their own in larger windows where their unique flowing fabric vanes allow you to enjoy both light and privacy.</p>

                    <p>Available in many in-trend colour options, Sierra blinds also help protect your floors and furniture from UV damage, with their silver foils which are placed inside the vanes while maintaining the outside view. You can select colours and fabrics that coordinate with other Callistus window blinds to create an integrated look in any room, or across your entire space.</p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>A brilliant new way to dress up your windows.</p>

                    <p>Callistus Sierra blind is a way of decorating your home that combines the practical qualities of slats with the warmth and intimacy of the curtains in a truly elegant manner.</p>

                    <p>Not only do they look great in the home but Sierra blinds are perfect for both domestic and commercial environments.</p>

                    <p>Their exclusive elegance is designed to improve the appearance of your interior and to provide a touch of style. These type of blinds integrate well with both – modern interiors as well as classical designs, because of the way they harmoniously combine practical attributes with distinctive allure.</p>

                    <p>If you’re looking to create an instant impact in your home with something a little different, then Sierra blinds would be a perfect choice. Sierra blinds really come into their own in larger windows where their unique flowing fabric vanes allow you to enjoy both light and privacy.</p>

                    <p>Available in many in-trend colour options, Sierra blinds also help protect your floors and furniture from UV damage, with their silver foils which are placed inside the vanes while maintaining the outside view. You can select colours and fabrics that coordinate with other Callistus window blinds to create an integrated look in any room, or across your entire space.</p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Vertical' },
                { label: 'Visibility', value: 'Blackout' },
                { label: 'Width (in mm)', value: '550 to 4500 (in Automation 4000)' },
            ],
           // video: "https://www.youtube.com/embed/lasqvEAXEwI?si=BDezP10XUEtFHS0l",
           video: "https://www.youtube.com/embed/nRR1NisUTqQ?si=fRBHnRfXrFohBdkQ",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Sierra blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/SierraBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/sierra-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/SierraBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to pre-set and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall.
                        </>
                },
                {
                    title: 'Wand Control',
                    image: '/Assets/SubPagesImages/SierraBlindsImages/wand-control-e1589892259253.webp',
                    description:
                        <>
                            <b>Callistus offers Wand control operating system</b> which makes sure that there are no dangerous cords, making them completely child and pet safe by design. You can control the blind and draw to either the left or right depending on your individual preference.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                <>
                    <p>
                        Sierra blind’s unique weave offers the ultimate shading flexibility and privacy along with modern stunning fabrics.
                    </p>
                    <p>
                        Cleverly combining the delicacy of a voile fabric with the versatility of rotating vertical louvres, Sierra blind looks sensational and offers a number of light and privacy options.
                    </p>
                    <p>
                        With the fabric vanes open during the day, you can still enjoy your view. When closed at night, you can have total privacy, and warmth.
                    </p>
                    <p>
                        All our blinds are of course child and pet safe and Sierra blinds is another example of this. It also comes with automation control, giving you complete peace of mind in a convenient, efficient and practical way.
                    </p>
                    <p>
                        Not to forget, Sierra Blinds come with embedded silver foil which provides UV Protection and insulation, saving energy eventually.
                    </p>
                </>
            ],
            combinations: [
                {
                    title: 'Fabric Vanes for Light and Privacy Control',
                    image: '/Assets/SubPagesImages/SierraBlindsImages/sierra-fabric-vanes-bottom.webp',
                    description:
                        <>
                            <b>Full View:</b> Slide the soft fabric vanes to one side or split from center to enjoy a clear outside view <br />

                            <b>Day Time with Privacy:</b> Open up the soft fabric vanes to the open position and enjoy subtle light diffusion with a view. <br />

                            <b>Total Privacy:</b> Rotate the vanes to close the blind fully for total privacy.
                        </>
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2401-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2402-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2403-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2404-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2405-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2406-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2407-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2421-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2422-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2423-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2424-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2425-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2441-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2442-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2443-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2444-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "grayson-blinds": {
        id: "grayson-blinds",

        // Page Meta Fields
        META_PG_Title: 'Grayson Blinds - the combination of Roller & Venetian Blinds',
        META_PG_OG_Description: 'Callistus Grayson Blinds give you privacy while offering view to outside by tilting vanes, creating beautiful gradations of light & shadow',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/grayson-blinds/',
        OG_Title: 'Grayson Blinds',

        name: "Grayson Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-slider-1.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-slider-2.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-slider-3.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-slider-4.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-01.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-02.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-03.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-04.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-05.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-06.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-07.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-08.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-09.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-10.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-11.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-12.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-13.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-14.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-insp-15.webp',
            ],
            text: [
                <>
                    <p>Callistus Grayson blinds give you privacy while offering a view to the outside. It is the combination of Roller & Venetian blinds. It easily creates beautiful gradations of light and shadow. Soft fabric vanes are suspended between two sheers, diffusing softened light deep into a room. Tilt the vanes to suit the privacy you desire.</p>

                    <p>Superbly stylish, Callistus Grayson blinds take the harshest sunlight and transform it into beautiful ambient natural light. Simply tilt the vanes to enjoy more natural daylight by diffusing it evenly throughout the room whilst filtering out brightness, glare and UV rays.</p>

                    <p>Callistus Grayson blinds are available in a wide range of beautiful fabrics with sophisticated in-trend colours.</p>

                    <p>Each fabric has its own unique feel, with a choice of silk looks, subtle linens – all designed to create softly filtered light.</p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>Callistus Grayson blinds give you privacy while offering a view to the outside. It is the combination of Roller & Venetian blinds. It easily creates beautiful gradations of light and shadow. Soft fabric vanes are suspended between two sheers, diffusing softened light deep into a room. Tilt the vanes to suit the privacy you desire.</p>

                    <p>Superbly stylish, Callistus Grayson blinds take the harshest sunlight and transform it into beautiful ambient natural light. Simply tilt the vanes to enjoy more natural daylight by diffusing it evenly throughout the room whilst filtering out brightness, glare and UV rays.</p>

                    <p>Callistus Grayson blinds are available in a wide range of beautiful fabrics with sophisticated in-trend colours.</p>

                    <p>Each fabric has its own unique feel, with a choice of silk looks, subtle linens – all designed to create softly filtered light.</p>
                    
                    

                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Translucent & Dimout' },
                { label: 'Width (in mm)', value: '500 to 2800' },
                { label: 'Drop (in mm)', value: '600 to 4500' },
            ],
         // video: "https://www.youtube.com/embed/cufEIlT-VQc?si=ICNbnrXpX_QFIu4O",
         video: "https://www.youtube.com/embed/KWtg1kHz9_Q?si=ReN0smnSB-zr0nqT",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Grayson Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/GraysonBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/grayson-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/GraysonBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to pre-set and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall.<br /><Link to="/grayson-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/GraysonBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            <b>Callistus Automation blinds </b> can be operated by using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                <>
                    <p>
                        Callistus Grayson blinds are the best choice for protecting privacy and controlling the light transmitted. Blind slices are clamped between two layers of sheer fabrics. Grayson Blinds close the gap between Venetian Blinds and Curtains in a truly unique design.
                    </p>
                    <p>
                        The shadings can be opened for a soft view, closed for complete privacy or tilted for flexible light control. They are durable and easy to clean.
                    </p>
                </>
            ],
            combinations: [
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/GraysonBlindsImages/grayson-blinds-decorative-cassette.webp',
                    description:
                        <>
                            Add a touch of luxury to your blind by adding a contemporary cassette. This system improves the look of the blind whether it is in the retracted or extended position. The blind gets a glamorous enhancement with a decorative cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.
                        </>
                },
                {
                    title: 'Fixing Option - Plain Cassette',
                    image: '/Assets/SubPagesImages/GraysonBlindsImages/grayson-blinds-plain-cassette.webp',
                    description:
                        <>
                            Give your blinds a sophisticated look by adding a sleek yet elegant plain cassette. If the blind is pulled up, the fabric in the upper part is wound onto the winding system. In this system, the roller lap is hidden in the box, whose size is determined according to the dimensions of the blinds. Plain Cassette completely encloses your blind’s mechanism thereby maintaining the integrity of your interior.
                        </>
                },
                {
                    title: 'Light Diffusion',
                    image: '/Assets/SubPagesImages/GraysonBlindsImages/grayson-blinds-solutions-diffusion.webp',
                    description:
                        <>
                            Simply tilt the vanes to enjoy more natural daylight by diffusing and spreading it evenly throughout the room whilst filtering out brightness, glare and UV rays.
                        </>
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/GraysonBlindsImages/9.-GTB-1762-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/8.-GDT-1707-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/3.-GDT-1710-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/6.-GKT-1724-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/5.-GAB-1754-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/4.-GFB-1742-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/2.-GDT-1703-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/1.-GCT-1771-thumb.webp'
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/grayson-blinds/grayson-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "roller-blinds": {
        id: "roller-blinds",
        // Page Meta Fields
        META_PG_Title: 'Roller Blinds for your Home & Office - Latest Window Coverings | Window Roller Shades | Roller Blinds Manufacturer | Best Price Roller Window Blinds | UK, UAE, Dubai | USA | Canada | Oman | Bahrain',
        META_PG_OG_Description: 'Roller Blinds Enlighten any space with colour, design & texture for spawning blackout. Dazzling choice of fabrics with 650+ awesome color shades. Roller Blinds are perfect for any setting seeing as they add style, functionality and appeal to the windows. Roller blinds are custom made to fit the size of your windows and are available in a number of designs blackout fabric. We are a leading Roller Blind Manufacturer with Global Presence. Available in translucent, dim-out and blackout fabrics. Motorization with remote control | Best Quality Durability Roller Blinds for Windows | Wide range of roller fabrics fabrics providing premium solution for room & office light control | UAE, UK, Oman, UK, Bahrain, Canada | Roller blinds enhances performance, look, appearance of home & office interiors | No compromise quality, manual & motorized remote controlled solution',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/producst/roller-blinds`,
        OG_Title: 'Roller Blinds',

        name: "Roller Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-01.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-02.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-03.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-04.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-05.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-06.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-07.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_01.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_02.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_03.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_04.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_05.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_06.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_07.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_08.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_09.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_10.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_11.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_12.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_13.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_14.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_15.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_16.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_17.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_18.webp',
            ],
            text: [
                <>
                    {/* <p>
                        Gently diffusing the light to create an astonishing ambience. Roller blinds can enlighten any space with its colour, design and texture. Let’s you control the natural light and spawning instant blackout. Callistus offers you the contemporary range meeting all your requirements.
                    </p>
                    <p>
                        Roller Blinds are the pinnacle of elegance when it comes to window coverings.
                    </p>
                    <p>
                        Callistus roller blinds are modern in design, stylish, reliable and easy to operate. A wide range of operating systems ensures the blind can be operated easily to achieve the required level of privacy and light control.
                    </p>
                    <p><b>Dazzling choice of fabrics with 550+ awesome designs and colours</b></p>
                    <p>
                        You can also add the finishing touches such as plain cassette, fabric decorative cassette, matching or covered bottom to personalise your choice and coordinate with your interior.
                    </p> */}
                    <b>Experience the Perfect Blend of Style and Functionality with Callistus Roller Blinds</b>
                    <p>
                        Gently diffusing light to create an astonishing ambience, our <b>custom roller blinds</b> transform every space with colour, design, and texture. Whether you’re searching for <b>roller blinds near me</b> or need expert <b>roller blinds installation,</b> Callistus offers a contemporary range meeting all your requirements.
                    </p>
                    <p>
                        Our <b>motorised roller blinds</b> bring smart comfort to your interiors, while <b>made to measure roller blinds</b> ensure a flawless fit for any window. From <b>blackout roller blinds for glass</b> to <b>roller blinds for home living rooms</b> and <b>commercial roller blinds for offices,</b> we provide tailored solutions for every space.
                    </p>
                    <p>
                        Callistus Roller Blinds are the pinnacle of elegance and functionality in modern window coverings. Stylish, reliable, and easy to operate, our systems offer perfect control over privacy and light - even for <b>roller blinds sun control solutions.</b>
                    </p>
                    <p>
                        With over <b>550+ dazzling fabrics, designs, and colours,</b> you can personalize every detail. Add the finishing touch with a plain or fabric decorative cassette, or match your bottom rail for a seamless look. Whether you prefer to <b>buy roller blinds online in India</b> or consult our experts in person, Callistus delivers unmatched sophistication and quality.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Gently diffusing the light to create an astonishing ambience. Roller blinds can enlighten any space with its colour, design and texture. Let’s you control the natural light and spawning instant blackout. Callistus offers you the contemporary range meeting all your requirements.
                    </p>
                    <p>
                        Roller Blinds are the pinnacle of elegance when it comes to window coverings.
                    </p>
                    <p>
                        Callistus roller blinds are modern in design, stylish, reliable and easy to operate. A wide range of operating systems ensures the blind can be operated easily to achieve the required level of privacy and light control.
                    </p>
                    <p><b>Dazzling choice of fabrics with 550+ awesome designs and colours</b></p>
                    <p>
                        You can also add the finishing touches such as plain cassette, fabric decorative cassette, matching or covered bottom to personalise your choice and coordinate with your interior.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Sheer, Translucent & Blackout' },
                { label: 'Width (in mm)', value: '300 to 3000' },
                { label: 'Drop (in mm)', value: '300 to 6000' },
            ],
          //  video: "https://www.youtube.com/embed/SdX-ARTzw-c?si=wwDBDt9hzBj6rrh4",
          video: "https://www.youtube.com/embed/ta5nZE_Rfdk?si=IWhgg6f04HLDDRp4",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Roller Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus Blinds is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind. <br /><Link to="/roller-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to pre-set and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall.<br /><Link to="/roller-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            <b>Callistus Automation blinds</b> can be operated by using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
                {
                    title: 'One Touch Up',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/one-tuch-up-e1590554714287.webp',
                    description:
                        <>
                            One Touch Up is a smart system wherein you just need to pull the operating cord once and the blind will roll up on its own.<br /><Link to="/roller-blinds-one-touch-up">Learn More</Link>
                        </>
                },
            ]
        },
        solutions: {
            text: [
                <>
                    <p className="solution-c-title">
                        Fabric that owns a unique feel
                    </p>
                    <p>
                        Callistus Blinds offer textures that are a literal treat to your eyes. With softness and drama of contrasting colours that come in natural and rough texture, they are not only reflective but also look icy elegant
                    </p>
                    <p>
                        <b>Callistus’s designer fabrics</b> <br />
                        Fabrics that raise the brows allowing your imaginations to run wild. Our wonderful collection allows you to choose from 650+ fabric colours, textures and patterns.
                    </p>
                    <p>
                        <b>Automation in Blinds</b> <br />
                        Automation in blinds gives your home a touch of originality, improves function and adds value. It makes complete sense for those hard to reach places. We offer a blend of design, technology and innovation that is easy to use and amazingly versatile. You can also choose from a wide range of portable controllers to fulfill all your automation needs and comforts
                    </p>
                    <p>
                        <b>Related Products:</b> <br />
                        <Link to="/products" >Window Blinds</Link> |
                        <Link to="/products/luzon-blinds" > Luzon Blinds</Link> |
                        <Link to="/products/roman-blinds" > Roman Blinds</Link>
                    </p>
                </>
            ],
            combinations: [
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/decorative-cassette-4.webp',
                    description:
                        <>
                            Add a touch of luxury to your blind by adding a contemporary cassette. This fixing improves the look of the blind whether it is in the retracted or extended position. The blind get a glamorous enhancement with a Decorative Cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.
                        </>
                },
                {
                    title: 'Fixing Option - Plain Cassette',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/plain-cassette-4-1.webp',
                    description:
                        <>
                            Give your blinds a sophisticated look by adding a sleek yet elegant Plain Cassette. If the blind is pulled up, the fabric in the upper part is wound onto the winding system. In this system, the roller lap is hidden in the cassette, whose size is determined according to the dimensions of the blinds. Plain Cassette completely encloses your blind’s mechanism thereby maintaining the integrity of your interior.
                        </>
                },
                {
                    title: 'Fixing Option - Headrail',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/head-rail-1.webp',
                    description:
                        <>
                            This is one of the leading fixing options. Headrails are essentially the part of the blind which accommodates the operating system that makes the blind go up and down. Headrail blends with any operating system, whether Automation or Manual. This fixing option also plays a vital role in maintaining the balance of in case of bigger size blinds.
                        </>
                },
                {
                    title: 'Fixing Option - Direct Fix',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/Roller-Blinds-Solution-Direct-Fix.webp',
                    description:
                        <>
                            Being a traditional fixing option, Direct Fix is simple and one of the most popular fixing option which is equipped with a chain mechanism. It works on clamps which can either be fixed as Ceiling Fix or Wall Fix.
                        </>
                },
                {
                    title: 'Bottom Rail',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/bottom-rail.webp',
                    description:
                        <>
                            Callistus provides various options in bottom rails according to the blinds. We have options of Round, Pentagon and Decorative Bottom Rails with 19 different colours to choose from. These Bottom Rails blend beautifully with the blinds enhancing their look by making them more stylish and sophisticated.
                        </>
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/RollerBlindsImages/9.-sisal-3616-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/8.-Harp-4027-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/7.-MAX-3648-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/6.-rio-3623-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/5.-mist-4004-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/4.-Colourex-3581-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/3.-Clio-3554-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/2.-missoni-3061-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/1.-STARTA-3045-thumb.webp'
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/roller-blinds/roller-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "wooden-venetian-blinds": {
        id: "wooden-venetian-blinds",
        // Page Meta Fields
        META_PG_Title: 'Wooden Venetian Blinds Natural Basswood Faux Metallic Series | Buy',
        META_PG_OG_Description: 'Decorate Windows with stunning, highly durable Wooden Venetian Blinds reflecting your style, luxury & premium crearing contemporary window look. See the full list of Venetian Blinds. Venetian Blinds styles for cosy ambience in every room of home & office. High Quality & Durable material for every Window Venetian Blinds, the perfect solution for every window with wooden venetian blinds.',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/wooden-venetian-blinds/`,
        OG_Title: 'Wooden Venetian Blinds',

        name: "Wooden Venetian Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-slider-01.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-slider-02.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-slider-03.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-slider-04.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-slider-05.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/Wooden_Inspiration_01.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/Wooden_Inspiration_02.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/Wooden_Inspiration_03.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/Wooden_Inspiration_04.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/Wooden_Inspiration_05.webp',
            ],
            text: [
                <>
                    <p>
                        <strong>Design and Finishing</strong> <br />
                        Callistus <strong>Wooden Venetian Blinds</strong> bring timeless elegance to any window. Crafted from premium <strong>Natural Basswood</strong> and our stylish <strong>Faux Metallic</strong> series, these <strong>wood blinds window</strong> solutions enhance interiors with warmth and sophistication. Whether you prefer <strong>real wood blinds</strong> or <strong>faux wood blinds</strong>, each piece is designed to reflect your personal style.
                    </p>

                    <p>
                        <strong>Perfect choice with a contemporary look</strong> <br />
                        Our classy range of <strong>custom wooden blinds</strong> is not only visually stunning but also built for durability. These <strong>moisture-resistant wooden blinds</strong> can withstand heat and humidity without fading or warping making them ideal for Indian homes, especially living rooms, kitchens, and bathrooms.
                    </p>

                    <p>
                        Whether you want soft daylight filtering, a clear outside view, or total privacy, Callistus’s <strong>wooden venetian blinds</strong> offer the perfect balance of style and function. Available in multiple series, textures, and colours, they effortlessly elevate any space—from modern living rooms to premium offices.
                    </p>

                    <p>
                        We also offer <strong>motorized wooden blinds</strong> for seamless smart control and <strong>made-to-measure wooden blinds</strong> for a perfect fit. As a leading <strong>wooden blinds manufacturer and supplier</strong>, Callistus ensures top quality with every product including popular options like <strong>PVC wood blinds</strong> and exclusive <strong>wooden blinds online India</strong> collections.
                    </p>

                    <p>
                        <strong>Slat Sizes Available:</strong> 35mm and 50mm
                    </p>

                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        <b>Design and Finishing</b> <br />Callistus Wooden Venetian blinds add a timeless style to your windows. Choose from a wonderful collection of Natural Basswood & Faux Metallic series to complete & add elegance to your interior. Enjoy a Wooden blind that reflects your style.
                    </p>
                    <p>
                        <b>Perfect choice with a contemporary look</b> <br />Callistus Wooden Venetian blinds add a timeless style to your windows. Choose from a wonderful collection of Natural Basswood & Faux Metallic series to complete & add elegance to your interior. Enjoy a Wooden blind that reflects your style.
                    </p>
                    <p>
                        Whether you want to gently filter daylight without spoiling the view or close them for total privacy or filtered light, Wooden Venetian blinds are a stylish and practical choice. Available in a range of series and colours, we have the perfect look for every room.
                    </p>
                    <p>
                        Slat Size (in mm) 35mm and 50mm
                    </p>
                </>
            ],
            specs: [
                { label: 'Slat Size (in mm)', value: '50 mm' },
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Width (in mm)', value: '300 to 2400 (in Faux Metallic Series 2900)' },
            ],
           // video: "https://www.youtube.com/embed/EDF9WOHNw08?si=aW9qTZeqGHBFFl05",
           video: "https://www.youtube.com/embed/Mlvmsv_g6xQ?si=rXBJiOZI1zwExlme",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Wooden Venetian Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/WoodenVenetianBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/wooden-venetian-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/WoodenVenetianBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to pre-set and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall.<br /><Link to="/wooden-venetian-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/WoodenVenetianBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            <b>Callistus Automation blinds</b> can be operated by using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                            <br /><Link to="/wooden-venetian-blinds-smart-phone-control">Learn More</Link>
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Design and Finishing',
                    image: null,
                    description:
                        <>
                            <p>
                                <b>Perfect choice with a contemporary look</b> <br />Our range of classy Wooden blinds aren’t just stunning, they’re also highly durable, so they can easily handle the heat & humidity without fading or warping.
                            </p>
                            <p>
                                <b>Customise as per your need</b> <br />You can combine different coloured slats to provide a fancy look to your interior. Personalize with a wide choice of sleek & decorative ladder tape to enrich the view of the blind. <br />
                                There are two types of mechanisms available for Wooden Venetian Blinds.<br />
                                1) ‘2 in 1’ mechanism in which lifting and tilting is done by same cord.<br />
                                2) ‘Standard Mechanism’ in which lifting and tilting is done by different cords.
                            </p>
                        </>
                },

                {
                    title: 'Valance System',
                    image: '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wv-blinds-valance-system.webp',
                    description: 'The valance will brilliantly cover the head rail, accentuating the beauty of the blind while concealing the operating system simultaneously.'
                },
                {
                    title: 'Ladder Tape',
                    image: '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wv-blinds-ladder-tape.webp',
                    description: 'Callistus has designed an attractive range of slim Ladder Tapes of 13mm which gives a sophisticated look and can complement your blinds. There are as many as 26 colours available to choose from, to match with your wooden slat. A different colour of ladder tape can also be used to give a contrasting look.'
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/9.-PD-76-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/8.-RS-03-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/7.-RS-01-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/6.-PD-78-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/5.-SP-51-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/4.-RS-08-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/3.-PD-80-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/2.-FM-33-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/1.-FM-31-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/wooden-venetian-blinds/wooden-slates",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "luzon-blinds": {
        id: "luzon-blinds",

        // Page Meta Fields
        META_PG_Title: 'Zebra Luzon Blinds - ideal balance of privacy and light control',
        META_PG_OG_Description: 'Luzon Blinds collection offers range of fabrics & colours to help you create statement look with stunningly eye-catching bold stripes',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/luzon-blinds`,
        OG_Title: 'Luzon Blinds',

        name: "Luzon Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/LuzonBlindsImages/Luzon-slider-1.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/Luzon-slider-2.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/Luzon-slider-3.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/Luzon-slider-4.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/Luzon-slider-5.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-1.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-2.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-3.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-4.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-5.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-6.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-7.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-8.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-9.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-10.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-11.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-12.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-13.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-14.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-15.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-16.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-17.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-18.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-19.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-20.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-21.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-22.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-insp-23.webp',
            ],
            text: [
                <>
                    <p>
                        <strong>Callistus Luzon Zebra Blinds</strong> are a contemporary window solution that combines aesthetic appeal with precise light control. Constructed from two alternating fabric bands — one translucent and one dimout — these blinds allow you to fine-tune how much sunlight and visibility you want. When the bands align, light filters softly; when offset, you get full privacy. This versatility makes them ideal as <strong>Luzon zebra curtains</strong> or <strong>zebra shades blinds</strong> for homes, offices, and designer interiors.
                    </p>

                    <p>
                        We offer a wide palette of fabrics and patterns, from subtle neutrals to bold <strong>printed zebra blinds</strong>, along with <strong>blackout zebra blinds</strong> for bedrooms and media rooms. For a perfect fit, our <strong>custom made zebra blinds</strong> are crafted to match your exact window dimensions.
                    </p>

                    <p>
                        For modern convenience, choose our <strong>motorised zebra blinds</strong> that integrate seamlessly with smart-home systems. You can explore samples and real installations at our <strong>Luzon zebra blinds showroom</strong>. We also assist with quotations and installation details, making it easy for you to compare <strong>Luzon zebra blinds price</strong> and quality.
                    </p>

                    <p>
                        Whether you search for <strong>Luzon zebra blinds near me</strong>, <strong>zebra window shades</strong>, or a premium <strong>designer zebra blinds</strong> solution for a statement window, Callistus Decor provides durable, stylish blinds that elevate your interiors while blocking harmful UV rays and enhancing comfort.
                    </p>

                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        <b>Callistus Luzon blinds</b> are an innovative window furnishing that features two layers of Visible-Translucent or Visible-Dimout horizontal striped fabric that combine to create a strikingly contemporary feel. Our collection offers you the perfect range of fabrics and colours to help you to create your statement look.
                    </p>
                    <p>
                        <b>Callistus Luzon Blinds,</b> also known as Zebra Blinds offer an amazing way to control light and privacy at any time of the day or night. To create the perfect look for your windows and interior, these blinds let you effortlessly slide two stylish fabrics past each other in an open, half-open or completely closed position.
                    </p>
                    <p>
                        <b>The Luzon blind</b> combines the ideal balance of privacy and light control with stunningly eye-catching bold stripes and UV blocking.
                    </p>
                    <p>
                        <b>Callistus Luzon Blinds</b> are available in a wide range of colours and fabrics. Luzon blinds also look spectacular in rooms with extra-large windows, creating a style statement along with light control.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Translucent & Blackout' },
                { label: 'Width (in mm)', value: '500 to 2850' },
                { label: 'Drop (in mm)', value: '500 to 5500' }
            ],
           // video: "https://www.youtube.com/embed/zDLrxvN5r4w?si=sNvy0xTknJxAsA-z",
           video: "https://www.youtube.com/embed/Of71JGb0djo?si=hacXtOVbZDylsG0R",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Luzon Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/LuzonBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/luzon-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/LuzonBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to pre-set and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall.<br /><Link to="/luzon-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/LuzonBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            <b>Callistus Automation blinds</b> can be operated by using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Luzon blinds are spectacular, stylish, reliable and easy to operate. An assortment of operating system options ensures the blind can be operated with convenience to achieve the required level of privacy and light control.
                            </p>
                            <p>
                                We offer a collection of 57 types of fabrics that raise the brows allowing your imaginations to run wild. The wonderful range allows you to choose from a wide variety of shades to match your interior.
                            </p>
                        </>
                },
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/LuzonBlindsImages/luzon-blinds-decorative-cassette.webp',
                    description: 'Add a touch of luxury to your blind by adding a contemporary cassette. This system improves the look of the blind whether it is in the retracted or extended position. The blind gets a glamorous enhancement with a decorative cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.'
                },
                {
                    title: 'Fixing Option - Plain Cassette',
                    image: '/Assets/SubPagesImages/LuzonBlindsImages/luzon-blinds-plain-cassette.webp',
                    description: 'Give your blinds a sophisticated look by adding a sleek yet elegant plain cassette. If the blind is pulled up, the fabric in the upper part is wound onto the winding system. In this system, the roller lap is hidden in the box, whose size is determined according to the dimensions of the blinds. Plain Cassette completely encloses your blind’s mechanism thereby maintaining the integrity of your interior.'
                },
                {
                    title: 'Fixing Option - Head Rail',
                    image: '/Assets/SubPagesImages/LuzonBlindsImages/luzon-blinds-head-rail.webp',
                    description: 'This is one of the leading fixing options. Headrails are essentially the part of the blind which accommodates the operating system that makes the blind go up and down. Headrails blends with any operating system whether Automation or Manual. This fixing option also plays a vital role in maintaining the balance of blinds for bigger measurements.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/LuzonBlindsImages/9.-LKB-1581-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/8.-LGT-1640-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/7.-LET-1506-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/6.-LGT-1634-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/5.-LDT-1552-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/4.-LFT-1522-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/3.-LLB-1603-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/2.-LVT-1615-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/1.-LHT-1572-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/luzon-blinds/luzon-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "skylight-blinds": {
        id: "skylight-blinds",

        // Page Meta Fields
        META_PG_Title: 'Skylight Blinds - making room brighter & open, giving spacious feel',
        META_PG_OG_Description: 'Sunlight can be a little glaring and can be uncomfortably hot. Callistus Skylight Blinds can make a considerable difference to comfort you',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/skylight-blinds`,
        OG_Title: 'Skylight Blinds',

        name: "Skylight Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-1.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-2.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-3.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-4.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-5.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-6.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-7.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-01.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-02.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-03.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-04.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-05.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-06.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-07.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-08.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-09.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-10.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-11.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-12.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-13.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-14.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-15.webp'
            ],
            text: [
                <>
                    <p>
                        Adding a <strong>skylight</strong> is an excellent way to make any room brighter and more open, creating a spacious and inviting feel. However, excess sunlight can sometimes cause glare and heat. This is where <strong>Callistus skylight blinds</strong> can make a significant difference in enhancing comfort inside your home.
                    </p>

                    <p>
                        Callistus offers a premium range of <strong>blinds for skylights</strong>, including both manual and <strong>motorized skylight blinds</strong> for effortless control. Our solutions also work beautifully as <strong>interior skylight covers</strong>, helping you manage light, heat, and privacy with ease.
                    </p>

                    <p>
                        Callistus <strong>Skylight Blinds</strong> have two options:
                    </p>

                    <p>
                        <strong>Skylight Colby Blinds</strong> <br />
                        Callistus <strong>Skylight Colby Blinds</strong> are a stylish, functional, and energy-efficient <strong>roof blinds</strong> solution. Ideal for various skylight sizes, they provide excellent insulation to maintain room temperature while adding a clean and modern touch to your space.
                    </p>

                    <p>
                        <strong>Skylight Roman Blinds</strong> <br />
                        Callistus <strong>Skylight Roman Blinds</strong> offer a refined, contemporary look. Designed without any visible stitch mechanism, these elegant <strong>skylight shades</strong> create a slim, seamless appearance with a luxurious finish—perfect for enhancing the aesthetic of your <strong>skylight window</strong>.
                    </p>

                    <p>
                        For homeowners seeking automation, Callistus also provides <strong>electric skylight shades</strong>, <strong>motorised blinds for skylights</strong>, and <strong>automated skylight shades</strong> combining advanced technology with superior style.
                    </p>

                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Adding a skylight can be a great way of making a room brighter and more open, giving a spacious feel.
                    </p>
                    <p>
                        But all that sunlight can be a little glaring and can be uncomfortably hot. This is where a Callistus Skylight blind can make a considerable difference to comfort you in your home.
                    </p>
                    <p>
                        Callistus Skylight blinds have two options:
                    </p>
                    <p>
                        <b>Colby Blinds</b><br />Callistus Skylight Colby blinds are stylish, functional, versatile, and energy efficient window covering solution. They are perfect for any window size and offer insulating properties to control room temperature without compromising on style.
                    </p>
                    <p>
                        <b>Roman Blinds</b><br />Callistus Skylight Roman blinds are elegant and provide a modern look.<br />
                        Callistus Roman blinds are fixed together without any stitch mechanism which offers a very slim look with a feeling of luxury.
                    </p>
                </>
            ],
            specs: [
                { label: 'Visibility', value: 'Sheer, Translucent & Blackout' },
                { label: 'Width (in mm)', value: '1000 to 1500' },
                { label: 'Drop (in mm)', value: '1000 to 4000' }
            ],
          //  video: "",
           // videoButton: ""
           video: "https://www.youtube.com/embed/7oqcU7T4L3o?si=EA4OdGBQgX7UClkI",
videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Skylight Blinds",
            systems: [
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/SkylightBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to pre-set and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall.<br /><Link to="/skylight-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Easy option for hard to reach Skylights',
                    image: null,
                    description:
                        <>
                            Wondering how you’d open and close a high, hard-to-reach <b>Skylight?</b> Our unique Automation systems give you added value and makes complete sense for those hard to reach places. We offer blend of design, technology & innovation so, you can choose from wide range of controllers to satisfy all your automation needs and comfort to make life easier – letting you control your blinds quickly and simply with a remote control.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Enjoy the Light and Control the heat',
                    image: null,
                    description: 'Skylights can often be an integral part of a conservatory and if you have a conservatory, you’ll know they can trap heat in summer and let heat out in the winter. There’s one easy answer – simply add a stylish, energy-efficient Skylight blind to give you temperature control throughout the year.'
                },
                {
                    title: 'The height of sophistication',
                    image: null,
                    description: 'Exclusive designs, contemporary & classic colours and textures, a choice of transparencies, our complete range of Skylight blinds offer the perfect look for every place. Visit our Callistus Gallery to see our complete range of gorgeous fabrics.'
                },
                {
                    title: 'Colby Fabrics',
                    image: '/Assets/SubPagesImages/SkylightBlindsImages/skylight-colby.webp',
                    description: 'Callistus Skylight Colby blinds are stylish, functional, versatile, energy efficient window covering solution. They are perfect for any size window and offer insulating properties to control room temperature without compromising on style.'
                },
                {
                    title: 'Roman Fabrics',
                    image: '/Assets/SubPagesImages/SkylightBlindsImages/skylight-roman.webp',
                    description: 'Callistus Skylight Roman blinds are elegant and provide a modern look. Callistus Roman blinds are fixed together without any stitch mechanism which offers a very slim look and a feeling of luxury.'
                },
                {
                    title: 'Unique Fabric Conversion in Roman Fabrics',
                    image: '/Assets/SubPagesImages/SkylightBlindsImages/skylight-unique-fabric-conversion-icons.png',
                    description: '1st Time in India – Callistus offers Visible to Translucent or Blackout and Translucent to Blackout conversion options available with all our Fabrics for Roman blinds which soothingly distribute and disperse light through the room providing ambience and character.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/SkylightBlindsImages/9.-1954-ckb.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/8.-1924-cmt.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/7.-1953-ckb.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/6.-1952-ckb.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/5.-1923-cmt.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/4.-1955-ckb.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/3.-1926-cmt.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/2.-1922-cmt.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/1.-1951-ckb.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/skylight-blinds/skylight-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "panel-blinds": {
        id: "panel-blinds",

        // Page Meta Fields
        META_PG_Title: 'Panel Blinds displaying the rich fabrics, colour and texture',
        META_PG_OG_Description: 'Panel Blinds are lustrous window decoration for larger windows, bi-fold or patio doors, & a fantastic choice for room dividers as well',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/panel-blinds`,
        OG_Title: 'Panel Blinds',

        name: "Panel Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-01.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-02.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-03.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-04.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-05.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-06.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-07.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-1.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-2.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-3.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-4.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-5.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-6.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-7.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-8.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-9.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-10.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-11.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-12.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-13.webp'
            ],
            text: [
                <>
                    <p>
                        <b>Make a statement and enhance your space with Callistus Panel blinds</b>
                    </p>
                    <p>
                        Transform your space with contemporary Panel Blinds. Callistus Panel blinds offer a sleek answer for both large and small window expanses. Open, they stack compactly to offer the maximum view; closed, they display their rich fabrics, colour and texture.
                    </p>
                    <p>
                        Panel blinds are an ideal choice for those who want to make an impact and add something a little different to their interior. With their flexible nature, not only do they make a lustrous window decoration for larger windows, bi-fold or patio doors, but they are a fantastic choice for room dividers as well.
                    </p>
                    <p>
                        <b>Dazzling choice of fabrics with 550+ awesome designs and colours</b>
                    </p>
                    <p>
                        Callistus range of fabric collection is available in Visible, translucent and blackout properties, whether it be a plain, pattern, print or textured fabric, with such a multitude of styles you really will be spoilt for choice with a stunning range of versatile colours, encompassing modern homes with redefined designs.
                    </p>
                   
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        <b>Make a statement and enhance your space with Callistus Panel blinds</b>
                    </p>
                    <p>
                        Transform your space with contemporary Panel Blinds. Callistus Panel blinds offer a sleek answer for both large and small window expanses. Open, they stack compactly to offer the maximum view; closed, they display their rich fabrics, colour and texture.
                    </p>
                    <p>
                        Panel blinds are an ideal choice for those who want to make an impact and add something a little different to their interior. With their flexible nature, not only do they make a lustrous window decoration for larger windows, bi-fold or patio doors, but they are a fantastic choice for room dividers as well.
                    </p>
                    <p>
                        <b>Dazzling choice of fabrics with 550+ awesome designs and colours</b>
                    </p>
                    <p>
                        Callistus range of fabric collection is available in Visible, translucent and blackout properties, whether it be a plain, pattern, print or textured fabric, with such a multitude of styles you really will be spoilt for choice with a stunning range of versatile colours, encompassing modern homes with redefined designs.
                    </p>
                   
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Vertical' },
                { label: 'Visibility', value: 'Sheer, Translucent & Blackout' },
                { label: 'Width (in mm)', value: '600 to 3000' },
                { label: 'Drop (in mm)', value: '600 to 4000' }
            ],
           // video: "https://www.youtube.com/embed/xRPviMwjlSw?si=I9RqybKMiGGxHhrA",
           video: "https://www.youtube.com/embed/NgCKHVWvYsA?si=Uu-ev5Z--XqqnAN-",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Panel Blinds",
            systems: [
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            Motorised Remote Control allows you to pre-set and easily operate window blinds with just a press of a button.<br /><Link to="/panel-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Wand Control',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/wand-control-e1589892259253.webp',
                    description:
                        <>
                            <b>Callistus offers Wand control for Panel blinds</b> so there are no dangerous cords, making them completely child and pet safe by Design. You can control the Panels draw to either the left or right depending on your individual circumstances.
                        </>
                },
                {
                    title: 'Cord Control',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/cord-control-e1589892901632.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous cord is used to open and close the blinds without any hassles.<br /><Link to="/panel-blinds-cord-control">Learn More</Link>
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Blinds offer textures that are a literal treat to your eyes. With softness and drama of contrasting colours that come in natural and rough texture, they are not only reflective but also look icy elegant.
                            </p>
                            <p>
                                You can choose either left or right draw panel blind to perfectly suit your window requirements. A versatile and contemporary way to control light, glare, view, and privacy; panel blinds provide an innovative shading solution for all windows and patio doors.
                            </p>
                        </>
                },
                {
                    title: 'Customize your blinds',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/panel-blinds-customization.webp',
                    description: 'Mix and match fabric colours and textures to create an eye-catching statement in your home. All of our fabrics ranges are also available as Roman & Roller blinds to give you perfect coordination throughout your home. Whatever you require we’ve got it covered.'
                },
                {
                    title: 'Tracks',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/panel-tracks.webp',
                    description: 'The Headrail in Panel blinds is available in 3 different variants. You can choose from 3, 4, and 6 track channels as per your requirement.'
                },
                {
                    title: 'Channel Stacking Option',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/stacking-option.webp',
                    description: 'You can modernize Panel Blinds by using Plain Channel or Matching Fabric Decorative Channel'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/PanelBlindsImages/9.-p2fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/8.-p3fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/7.-p1fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/6.-rio-fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/5.-voil-fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/4.-mist-fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/3.-dapple-fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/2.-colortex-fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/1.-plaintex-fabric.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/panel-blinds/panel-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "roman-blinds": {
        id: "roman-blinds",

        // Page Meta Fields
        META_PG_Title: 'Roman Blinds - Greater Choice with Trending Designs',
        META_PG_OG_Description: 'Roman Blinds are versatile and provide neat modern look. Fold by fold raising property elevates oomph factor by creating soft layered effect',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/roman-blinds`,
        OG_Title: 'Roman Blinds',

        name: "Roman Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-slider-01.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-slider-02.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-slider-03.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-slider-04.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-slider-05.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-slider-06.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-slider-07.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-inspiration-1.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-inspiration-2.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-inspiration-3.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-inspiration-4.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-inspiration-5.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-inspiration-6.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-inspiration-7.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-inspiration-8.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-inspiration-9.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/Roman-inspiration-10.webp'
            ],
            text: [
                <>
                    {/* <p>
                        Roman blinds are very versatile and provide a neat modern look. Fold by fold raising property elevates the oomph factor by creating a soft layered effect. Unlike other Roman blinds which are traditionally stitched together, Callistus Roman blinds are fixed together by using PVC rod and powder coated channel that deter any amount of light to pass through and offer rust resistance in any climate.
                    </p>
                    <p>
                        <b>Unique Fabric Conversion (1st Time in India) –</b> Callistus Roman Blinds offer Visible to Translucent or Blackout, and Translucent to Blackout conversion options available with all our fabrics which soothingly disperse light through the room, providing an astonishing ambience.
                    </p>
                    <p>
                        <b>Greater choice with in-trend designs –</b> Callistus Range of fabric collection is available in more than 550+ stunning and dazzling range of distinctive and versatile colours, encompassing modern homes with refined designs.
                    </p> */}
                    <b>Experience the elegance of Roman Blinds - a perfect blend of design, technology, and functionality.</b>
                    <p>
                        Callistus <b>Roman Blinds India</b> collection brings sophistication to every space with a <b>neat, modern look</b> and smooth fold-by-fold movement that creates a <b>soft, layered effect.</b> Unlike ordinary <b>fabric Roman blinds,</b> our <b> premium Roman blinds</b> are crafted with <b>PVC rods</b> and <b>powder-coated channels,</b> ensuring zero light leakage, rust resistance, and long-lasting performance in any climate.
                    </p>
                    <p>
                        As a <b>premium Roman blinds manufacturer,</b> Callistus introduces <b>Unique Fabric Conversion Technology (1st time in India)</b> - transforming <b>visible to translucent or blackout,</b> and <b>translucent to blackout</b> modes across all fabrics. This smart innovation makes our <b>motorised Roman blinds</b> and <b>custom Roman blinds</b> ideal for creating soothing ambience and perfect <b>sun control.</b>
                    </p>
                    <p>
                        With over <b>550+ modern Roman blinds designs,</b> our collection caters to <b>interior designers,</b> homeowners, and commercial spaces alike. Explore our <b>luxury Roman blinds</b> and <b>Roman blinds for windows or bedrooms</b> - or even <b>Roman shades and curtains</b> combinations that redefine interior style.
                    </p>
                    <p>
                        Looking to <b>buy Roman blinds online in India</b> or searching for <b>Roman blinds near me?</b><br />
                        Discover Callistus’s exclusive range of <b>Roman shade blinds, Roman blinds curtains,</b> and <b>blinds and Roman shades</b> - where craftsmanship meets innovation for timeless elegance.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Roman blinds are very versatile and provide a neat modern look. Fold by fold raising property elevates the oomph factor by creating a soft layered effect. Unlike other Roman blinds which are traditionally stitched together, Callistus Roman blinds are fixed together by using PVC rod and powder coated channel that deter any amount of light to pass through and offer rust resistance in any climate.
                    </p>
                    <p>
                        <b>Unique Fabric Conversion (1st Time in India) – </b> Callistus Roman Blinds offer Visible to Translucent or Blackout, and Translucent to Blackout conversion options available with all our fabrics which soothingly disperse light through the room, providing an astonishing ambience.
                    </p>
                    <p>
                        <b>Greater choice with in-trend designs –</b> Callistus Range of fabric collection is available in more than 550+ stunning and dazzling range of distinctive and versatile colours, encompassing modern homes with refined designs.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Sheer, Translucent & Blackout Fabric conversion available' },
                { label: 'Width (in mm)', value: '500 to 3000' },
                { label: 'Drop (in mm)', value: '1000 to 4000' }
            ],
           // video: "https://www.youtube.com/embed/dhpH7ueOQ9o?si=wsUHWlXHSFeEGgTh",
           video: "https://www.youtube.com/embed/8tVibIgs3Io?si=NcJmzGON714sxQhI",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Roman Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/roman-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to pre-set and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall.<br /><Link to="/roman-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            <b> Callistus Automation blinds</b> can be operated by using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
                {
                    title: 'One Touch Down',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/one-touch-down-e1589892347547.webp',
                    description:
                        <>
                            One Touch Down is a smart system wherein you just need to pull the operating cord and the blind will start unfolding on its own.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Blinds offer textures that are a literal treat to your eyes. With softness and drama of contrasting colours that come in natural and rough texture, they are not only reflective but also look icy elegant
                            </p>
                            <p>
                                <b>Callistus’s designer fabrics</b> <br />
                                Fabrics that raise the brows allowing your imaginations to run wild. Our wonderful collection allows you to choose from an array of fabric colours, textures and patterns.
                            </p>
                            <p>
                                <b>Automation in Blinds</b><br />
                                Automation in blinds gives your home a touch of originality, improves function and adds value. Makes complete sense for those hard to reach places. We offer a blend of design, technology and innovation that is easy to use and amazingly versatile. You can also choose from a wide range of portable controllers to fulfil all your automation needs and comforts.
                            </p>
                        </>
                },
                {
                    title: 'Unique Fabric Conversion',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/roman-blinds-unique-fabric-conversion.png',
                    description: '1st Time in India – Callistus offers conversion of Visible to Translucent or Blackout, and Translucent to Blackout with all our Fabrics for Roman blinds which soothingly distribute and disperse light through the room providing ambience and character.'
                },
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/Roman-Decorative-Cassette.webp',
                    description: 'Add a touch of luxury to your blind by adding a contemporary cassette. This system improves the look of the blind whether it is in the retracted or extended position. The blind gets a glamorous enhancement with a decorative cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.'
                },
                {
                    title: 'Bottom Rail',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/Roman-Blinds-Solutions-Bottom-Options-1.webp',
                    description: 'Callistus provides various options in bottom rails according to the blinds. We have options of Pentagon and Decorative bottom rails with 19 different colours to choose from. These bottom rails blend beautifully with the blinds enhancing their look by making them more stylish and sophisticated.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/RomanBlindsImages/8.-Candid-3011-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/7.-Faustina-4016-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/6.-Blesbok-3505-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/5.-Bloom-3056-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/4.-Loden-3534-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/3.-Tafetta-3002-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/2.-Alayna-3566-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/1.-Geo-3026-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/9.-Jamboree-3653-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/roman-blinds/roman-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "aric-blinds": {
        id: "aric-blinds",

        // Page Meta Fields
        META_PG_Title: 'Aric Blinds - the combination of Roller and Vertical Blinds',
        META_PG_OG_Description: 'Exclusive feature that facilitates the opening & closing of sheer part at same position of the blind without rolling the blind up or down',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/aric-blinds`,
        OG_Title: 'Aric Blinds',

        name: "Aric Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/AricBlindsImages/aric-slider-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-slider-2.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-slider-3.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-slider-4.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-slider-5.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-2.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-3.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-4.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-5.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-6.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-7.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-8.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-9.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-10.webp'
            ],
            text: [
                <>
                    <p>
                        An innovative operating system introduced for the first time in India. Aric Blinds offer customers a unique experience with operations of Roller and Vertical blinds simultaneously. They have an exclusive feature that facilitates the opening and closing the sheer part at the same position of the blind without rolling the blind up or down. These blinds always cover the window and hence offer continuous UV protection. Enjoy facility of Roller & Vertical Blinds from Aric Blinds.
                    </p>
                    <p>
                        An amazingly stylish and simple way to control light and privacy at any time of the day or night. Aric blinds combine the ideal balance of privacy and light control with the fashionable, eye-catching trend of bold stripes and colour blocking. Callistus Aric blinds are available in a wide array of colours and fabrics.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Gently diffusing the light to create an astonishing ambience. Roller blinds can enlighten any space with its colour, design and texture. Let’s you control the natural light and spawning instant blackout. Callistus offers you the contemporary range meeting all your requirements.
                    </p>
                    <p>
                        Roller Blinds are the pinnacle of elegance when it comes to window coverings.
                    </p>
                    <p>
                        Callistus roller blinds are modern in design, stylish, reliable and easy to operate. A wide range of operating systems ensures the blind can be operated easily to achieve the required level of privacy and light control.
                    </p>
                    <p>
                        <b>Dazzling choice of fabrics with 550+ awesome designs and colours</b>
                    </p>
                    <p>
                        You can also add the finishing touches such as plain cassette, fabric decorative cassette, matching or covered bottom to personalise your choice and coordinate with your interior.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Combination of Horizontal and Vertical' },
                { label: 'Visibility', value: 'Translucent' },
                { label: 'Width (in mm)', value: '550 to 2500' },
                { label: 'Drop (in mm)', value: '550 to 2500' }
            ],
            video: "https://www.youtube.com/embed/UEKvqzxf6rI?si=n51NF40rAUeiaq6C",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Aric Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/AricBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/aric-blinds-manual">Learn More</Link>
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description: 'Callistus Aric blinds are modern in design, stylish, reliable and easy to operate. Fabrics that raise the brows allowing your imaginations to run wild. Our wonderful collection allows you to choose from a wide assortment of fabrics.'
                },
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/AricBlindsImages/aric-blind-decorative-cassette.webp',
                    description: 'Add a touch of luxury to your blind by adding a contemporary cassette. This system improves the look of the blind whether it is in the retracted or extended position. The blind gets a glamorous enhancement with a decorative cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.'
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/AricBlindsImages/AST-2101-300x167-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/AST-2102-300x167-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/AST-2103-300x167-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/AST-2104-300x167-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/AST-2105-300x167-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/AST-2106-300x167-1.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "patricia-blinds": {
        id: "patricia-blinds",

        // Page Meta Fields
        META_PG_Title: 'Patricia Blinds - luxurious to look & latest trendsetter interior',
        META_PG_OG_Description: 'It folds up in most stylish manner forming a unique flower pattern towards bottom that makes room look aesthetic even when blinds are open',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/patricia-blinds`,
        OG_Title: 'Patricia Blinds',

        name: "Patricia Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-1.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-2.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-3.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-4.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-5.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-6.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-1.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-2.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-3.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-4.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-5.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-6.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-7.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-8.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-9.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-10.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-11.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-12.webp'
            ],
            text: [
                <>
                    <p>
                        Patricia Blinds are luxurious to look at and are the latest trendsetter in interior designing. They fold up in the most stylish manner forming a unique flower pattern towards the bottom that makes the room look magnificent even when the blinds are open. They come in a variety of colours and texture that match your interior.
                    </p>
                    <p>
                        Callistus Patricia blinds are beautiful and elegant that allow you to decorate your interior in the most pleasant and cheerful manner. The range of colours and texture available help you build your dream interior with matching Ladder Tapes.
                    </p>
                    <p>
                        Callistus Patricia blinds are an innovative window furnishing that features translucent horizontal striped fabric that combines to create a strikingly modern feel. Our collection offers you the perfect range of fabrics and colours to help you create your statement look.
                    </p>
                    <p>
                        Callistus Patricia blind’s decorative lace lets you effortlessly create the perfect look for your window, your mood, and your home. These blinds are amazingly stylish, offering a simple way to control light and privacy at any time of the day or night.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Patricia Blinds are luxurious to look at and are the latest trendsetter in interior designing. They fold up in the most stylish manner forming a unique flower pattern towards the bottom that makes the room look magnificent even when the blinds are open. They come in a variety of colours and texture that match your interior.
                    </p>
                    <p>
                        Callistus Patricia blinds are beautiful and elegant that allow you to decorate your interior in the most pleasant and cheerful manner. The range of colours and texture available help you build your dream interior with matching Ladder Tapes.
                    </p>
                    <p>
                        Callistus Patricia blinds are an innovative window furnishing that features translucent horizontal striped fabric that combines to create a strikingly modern feel. Our collection offers you the perfect range of fabrics and colours to help you create your statement look.
                    </p>
                    <p>
                        Callistus Patricia blind’s decorative lace lets you effortlessly create the perfect look for your window, your mood, and your home. These blinds are amazingly stylish, offering a simple way to control light and privacy at any time of the day or night.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Translucent' },
                { label: 'Width (in mm)', value: '750 to 4500' },
            ],
            //video: "https://www.youtube.com/embed/M-90o7MVyug?si=xYMA8sLUJXd02Kjj",
            video: "https://www.youtube.com/embed/6zQmiAr7-9Y?si=n2yw7sDBs-ayJIz7",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Patricia Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/PatriciaBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/patricia-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/PatriciaBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to pre-set and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall.<br /><Link to="/patricia-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/PatriciaBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            <b>Callistus Automation blinds</b> can be operated by using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Patricia blinds are modern in design, stylish, reliable and easy to operate. The wide range of operating system ensures the blind can be operated easily to achieve the required level of privacy and light control for you.
                            </p>
                            <p>
                                Callistus Patricia blinds are an innovative window covering that feature translucent horizontal striped fabric which combines to create a strikingly contemporary feel. Our collection offers you the perfect range of fabrics and colours to help you create your statement look.
                            </p>
                            <p>
                                Give your blinds a glamorous enhancement with a matching fabric decorative cassette accompanied by a fascinating lace at the bottom.
                            </p>
                        </>
                },
                {
                    title: 'Unique Flower Pattern',
                    image: '/Assets/SubPagesImages/PatriciaBlindsImages/paricia-blinds-unique-flower-pattern.webp',
                    description: 'The distinctive feature of Patricia Blinds is the shaping up of Flower Pattern. Whilst open, the flower formation of the blind adds a unique value to your windows and adjacent interiors.'
                },
                {
                    title: 'Fabric Decorative Cassette',
                    image: '/Assets/SubPagesImages/PatriciaBlindsImages/paricia-blinds-fabric-decorative-cassette.webp',
                    description: 'Add a touch of luxury to your blind by adding a contemporary cassette. This system improves the look of the blind whether it is in the retracted or extended position. The blind gets a glamorous enhancement with a decorative cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.'
                },
                {
                    title: 'Decorative Lace',
                    image: '/Assets/SubPagesImages/PatriciaBlindsImages/paricia-blinds-decorative-lace.webp',
                    description: 'The decorative lace is an alluring insertion to the blind. Ingrained with a mild steel strip for support, the lace plays a versatile role in the blind, essentially adding a touch of conventional decorative articles.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/PatriciaBlindsImages/2.-PCT-2301-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/1.-PCT-2302-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/7.-PCT-2303-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/8.-PCT-2304-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/3.-PCT-2305-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/4.-PCT-2306-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/6.-PCT-2307-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/5.-PCT-2308-th-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "dorren-blinds": {
        id: "dorren-blinds",

        // Page Meta Fields
        META_PG_Title: 'Upgrade of triple shade & has fashionable style of Venetian Blind',
        META_PG_OG_Description: 'A remarkably stylish way to control light & privacy, Callistus Dorren Blinds create perfect look for your window, your mood & your space',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/dorren-blinds`,
        OG_Title: 'Dorren Blinds',

        name: "Dorren Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-slider-1.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-slider-2.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-slider-3.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-slider-4.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-slider-5.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-1.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-2.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-3.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-4.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-5.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-6.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-7.webp'
            ],
            text: [
                <>
                    <p>
                        Dorren blinds have a unique design and are exceptionally easy to operate. They are an upgrade of a triple shade product that has a fashionable style of a Venetian blind.
                    </p>
                    <p>
                        A remarkably stylish and effortless way to control light and privacy during the day or night, Callistus Dorren blinds lets you effortlessly create the perfect look for your window, your mood and your home.
                    </p>
                    <p>
                        Callistus Dorren blinds are available in a wide collection of colours and fabrics. Dorren blinds also look striking in rooms with extra-large windows creating a real style statement with excellent light control.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Dorren blinds have a unique design and are exceptionally easy to operate. They are an upgrade of a triple shade product that has a fashionable style of a Venetian blind.
                    </p>
                    <p>
                        A remarkably stylish and effortless way to control light and privacy during the day or night, Callistus Dorren blinds lets you effortlessly create the perfect look for your window, your mood and your home.
                    </p>
                    <p>
                        Callistus Dorren blinds are available in a wide collection of colours and fabrics. Dorren blinds also look striking in rooms with extra-large windows creating a real style statement with excellent light control.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Translucent' },
                { label: 'Width (in mm)', value: '500 to 2800' },
                { label: 'Drop (in mm)', value: '600 to 4500' }
            ],
           // video: null,
            //videoButton: null
            video: "https://www.youtube.com/embed/OVHOsyyHvMQ?si=dXOGlzmDizlL14mH",
videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Dorren Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/DorrenBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind<br /><Link to="/dorren-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/DorrenBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to pre-set and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall.
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/DorrenBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            Callistus Automation blinds can be operated using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Dorren blinds are uniquely designed, elegant, reliable and easy to operate. Many options of operating system ensure the blind can be operated conveniently, to achieve the required level of privacy and light control.
                            </p>
                            <p>
                                Dorren Blinds add a touch of spectacular beauty to your interior.
                            </p>
                        </>
                },
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-decorative-cassette.webp',
                    description: 'Add a touch of luxury to your blind by adding a contemporary cassette. This system improves the look of the blind whether it is in the retracted or extended position. The blind gets a glamorous enhancement with a decorative cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.'
                },
                {
                    title: 'Fixing Option - Plain Cassette',
                    image: '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-plain-cassette.webp',
                    description: 'Give your blinds a sophisticated look by adding a sleek yet elegant plain cassette. When the blind is pulled up, the fabric in the upper part is wound onto the winding system. In this system, the roller lap is hidden in the box, whose size is determined according to the dimensions of the blinds. Plain Cassette completely encloses your blind’s mechanism thereby maintaining the integrity of your interior.'
                },
                {
                    title: 'Light Diffusion',
                    image: '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-light-diffusion.webp',
                    description: 'Simply tilt the vanes to enjoy more natural daylight by diffusing and spreading it evenly throughout the room whilst filtering out brightness, glare and UV rays.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/DorrenBlindsImages/1.-DVT-2501-300x167.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/4.-DVT-2502-300x167.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/2.-DVT-2503-300x167.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/3.-DVT-2504-300x167.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/5.-DVT-2505-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "meliso-blinds": {
        id: "meliso-blinds",

        // Page Meta Fields
        META_PG_Title: 'Meliso Blinds - Fusion of practicality of Roller while adding look of Roman',
        META_PG_OG_Description: 'Meliso Blinds - with gentle pull of cord, textured fabric in palette of delightful colors transforms from contoured folds to opened vanes',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/meliso-blinds`,
        OG_Title: 'Meliso Blinds',

        name: "Meliso Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-slider-1.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-slider-2.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-slider-3.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-slider-4.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-insp-01.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-insp-02.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-insp-03.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-insp-04.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-insp-05.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-insp-06.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-insp-07.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-insp-08.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-insp-09.webp',

            ],
            text: [
                <>
                    <p>Let softly diffused light spill into your favourite room.</p>

                    <p>Callistus Meliso Blind combines the personality of a classic fabric shade with the ability to control light in an entirely new way. With the gentle pull of the operating cord, textured fabric in a palette of delightful colours transforms from contoured folds to opened vanes, allowing a softened outside view through the sheer backing.</p>

                    <p>These modern blinds are designed delicately and creatively. They are a fusion of the practicality of Roller Blinds while adding the look of Roman Blinds when pulled up.</p>

                    <p>When the Blinds are drawn, they have horizontal stripes as their signature design created with their fabric and have a unique feature of coming down like roller blinds. The sheer look adds an elegant touch to the ordinary roller blinds and roman blinds and brings out a new look altogether.</p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>Let softly diffused light spill into your favourite room.</p>

                    <p>Callistus Meliso Blind combines the personality of a classic fabric shade with the ability to control light in an entirely new way. With the gentle pull of the operating cord, textured fabric in a palette of delightful colours transforms from contoured folds to opened vanes, allowing a softened outside view through the sheer backing.</p>

                    <p>These modern blinds are designed delicately and creatively. They are a fusion of the practicality of Roller Blinds while adding the look of Roman Blinds when pulled up.</p>

                    <p>When the Blinds are drawn, they have horizontal stripes as their signature design created with their fabric and have a unique feature of coming down like roller blinds. The sheer look adds an elegant touch to the ordinary roller blinds and roman blinds and brings out a new look altogether.</p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Translucent' },
                { label: 'Width (in mm)', value: '500 to 2600' },
            ],
          //  video: "https://www.youtube.com/embed/sQh4OksGmfI?si=KOMSzOWM9G76BQBz",
          video: "https://www.youtube.com/embed/Vt-hIM4htEU?si=noORxW7YO9cybo_C",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Meliso Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/MelisoBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/MelisoBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to pre-set and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall.<br /><Link to="/meliso-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/MelisoBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            <b>Callistus Automation blinds</b> can be operated by using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Meliso blinds are modern in design, stylish, reliable and easy to operate. Largest range of operating system ensures the blind can be rolled up or down easily to achieve the required level of privacy and light control.
                            </p>
                        </>
                },
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/MelisoBlindsImages/meliso-blinds-decorative-cassette.webp',
                    description: 'Add a touch of luxury to your blind by adding a contemporary cassette. This system improves the look of the blind whether it is in the retracted or extended position. The blind gets a glamorous enhancement with a decorative cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.'
                },
                {
                    title: 'Fixing Option - Plain Cassette',
                    image: '/Assets/SubPagesImages/MelisoBlindsImages/meliso-blinds-plain-cassette.webp',
                    description: 'Give your blinds a sophisticated look by adding a sleek yet elegant plain cassette. If the blind is pulled up, the fabric in the upper part is wound onto the winding system. In this system, the roller lap is hidden in the box, whose size is determined according to the dimensions of the blinds. Plain Cassette completely encloses your blind’s mechanism thereby maintaining the integrity of your interior.'
                },
                {
                    title: 'Light Diffusion',
                    image: '/Assets/SubPagesImages/MelisoBlindsImages/meliso-blinds-light-diffusion.webp',
                    description: 'Simply tilt the vanes to enjoy more natural daylight by diffusing and spreading it evenly throughout the room whilst filtering out brightness, glare and UV rays.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/MelisoBlindsImages/1.-MDT-2001-300x167.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/2.-MDT-2002-300x167.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/3.-MDT-2003-300x167.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/4.-MDT-2004-300x167.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/5.-MDT-2005-300x167.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/6.-MDT-2006-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "vertical-blinds": {
        id: "vertical-blinds",

        // Page Meta Fields
        META_PG_Title: 'Vertical Blinds with wide range of fabrics, colors, textures & patterns',
        META_PG_OG_Description: 'Sliding glass doors, bay windows look prettier with our custom-made Vertical Blinds, which feature easy operation and superior light control.',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/vertical-blinds`,
        OG_Title: 'Vertical Blinds',

        name: "Vertical Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/VerticalBlindsImages/vertical-blinds-1.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/vertical-blinds-2.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/vertical-blinds-3.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/vertical-blinds-4.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/vertical-blinds-5.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-1.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-2.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-3.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-4.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-5.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-6.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-7.webp'
            ],
            text: [
                <>
                    <p>
                        Easy, precise light control. Everything from sliding glass doors to bay windows looks prettier with our Custom-made Callistus Vertical Blinds, which feature easy operation and superior light control. Available in a wide range of fabrics and an impressive array of colours, textures, and patterns.
                    </p>
                    <p>
                        Sliding doors can let a lot of light in. Consider using a light-filtering, room darkening, or blackout Vertical blind on them to help protect furnishings from fading, and to give you more privacy. Enhanced light control can also help reduce energy costs.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Easy, precise light control. Everything from sliding glass doors to bay windows looks prettier with our Custom-made Callistus Vertical Blinds, which feature easy operation and superior light control. Available in a wide range of fabrics and an impressive array of colours, textures, and patterns.
                    </p>
                    <p>
                        Sliding doors can let a lot of light in. Consider using a light-filtering, room darkening, or blackout Vertical blind on them to help protect furnishings from fading, and to give you more privacy. Enhanced light control can also help reduce energy costs.
                    </p>
                </>
            ],
            specs: [
                { label: 'Louvre Size (in mm)', value: '100' },
                { label: 'Orientation', value: 'Vertical' },
                { label: 'Width (in mm)', value: '500 to 4500 (with Automation 4000)' },
                { label: 'Drop (in mm)', value: '400 to 4500' },
            ],
            video: null,
            videoButton: null
        },
        operatingSystems: {
            title: "Available Operating Systems for Vertical Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/VerticalBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/VerticalBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to pre-set and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colors and can also be affixed to a wall.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Blinds offer textures that are a literal treat to your eyes. With softness and drama of contrasting colours that come in natural and rough texture, they are not only reflective but also look icy elegant.
                            </p>
                            <p>
                                You can choose either left right or centre split draw in vertical blind to perfectly suit your window requirements. A versatile and contemporary way to control light, glare, view and privacy, vertical blinds provide an innovative shading solution for all size of windows and patio doors.
                            </p>
                        </>
                },
                {
                    title: 'Customize your blinds',
                    image: null,
                    description: 'Mix and match fabric colours and textures to create an eye-catching statement in your home/office. There are 100+ fabrics range available to give you perfect coordination throughout your interior. Whatever you require we’ve got it!   '
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/VerticalBlindsImages/9.-revolve.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/8.-lark.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/7.-screenline.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/6.-Zig-Zag.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/5.-jentex.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/4.-impact.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/3.-ample2.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/2-equate-thumb-300x167-1.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/1-Flaxen-thumb-300x167-1.webp'
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/vertical-blinds/vertical-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "eton-blinds": {
        id: "eton-blinds",

        // Page Meta Fields
        META_PG_Title: 'Eton Blinds - soft intimate feel of Curtains & unique benefits of blinds',
        META_PG_OG_Description: 'Eton Blinds - perfect for any window size. Drawn open like curtains & fabric vanes can be rotated with the simple twist of the wand',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/eton-blinds`,
        OG_Title: 'Eton Blinds',

        name: "Eton Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-04.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-06.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-07.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-08.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-01-2.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-05.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-02-2.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-03-2.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/EtonBlindsImages/eton-insp-01.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-insp-02.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-insp-03.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-insp-04.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-insp-05.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-insp-06.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-insp-07.webp',
            ],
            text: [
                <>
                    <p>Get the look of a Curtain with features of a Blind.</p>

                    <p>Callistus Eton blinds offer a softly filtered view providing privacy with easily controlled tilting vanes. The luxurious look of soft curtains is accentuated at night when the blind is closed. Callistus Eton Blinds control sunlight in the most elegant manner.</p>

                    <p>Eton Blinds can be used virtually in any room, and are perfect for any window size.</p>

                    <p>Drawn open like curtains, the sheers can be drawn closed and the fabric vanes can be rotated like Vertical blinds, with the simple twist of the wand.</p>

                    <p>An amazingly stylish and simple way to control light and privacy at any time of the day or night. Callistus Eton blinds let you effortlessly slide two stylish fabrics past each other in an open, half-open or completely closed position to create the perfect look.</p>

                    <p>Callistus Eton blind combines the ideal balance of privacy and light control with fashionable and eye-catching colours.</p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>Get the look of a Curtain with features of a Blind.</p>

                    <p>Callistus Eton blinds offer a softly filtered view providing privacy with easily controlled tilting vanes. The luxurious look of soft curtains is accentuated at night when the blind is closed. Callistus Eton Blinds control sunlight in the most elegant manner.</p>

                    <p>Eton Blinds can be used virtually in any room, and are perfect for any window size.</p>

                    <p>Drawn open like curtains, the sheers can be drawn closed and the fabric vanes can be rotated like Vertical blinds, with the simple twist of the wand.</p>

                    <p>An amazingly stylish and simple way to control light and privacy at any time of the day or night. Callistus Eton blinds let you effortlessly slide two stylish fabrics past each other in an open, half-open or completely closed position to create the perfect look.</p>

                    <p>Callistus Eton blind combines the ideal balance of privacy and light control with fashionable and eye-catching colours.</p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Vertical' },
                { label: 'Visibility', value: 'Translucent' },
                { label: 'Width (in mm)', value: '500 to 4500 mm' },
            ],
          //  video: null,
            //videoButton: null
            video: "https://www.youtube.com/embed/Gzxsw47JCVI?si=rps8qgLYlJNzPs53",
videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Eton Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/EtonBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus Blinds</b> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/eton-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Wand Control',
                    image: '/Assets/SubPagesImages/EtonBlindsImages/wand-control-e1589892259253.webp',
                    description:
                        <>
                            <b>Callistus offers Wand control operating system</b> which makes sure that there are no dangerous cords, making them completely child and pet safe by design. You can control the blind and draw to either the left or right depending on your individual preference.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Eton blinds are well designed, easy to operate, stylish, and durable. A wide array of operating systems ensures the blind can be tilted easily to achieve the required level of light and privacy.
                            </p>
                            <p>
                                Our Eton blinds sweep elegantly across your windows and doors creating a luxurious ambience in your room.
                            </p>
                            <p>
                                Make Eton blinds your first choice for a beautiful look and full flexibility for your living space.
                            </p>
                            <p>
                                By adding a designer look to your home interiors Eton blinds will give you a wow feeling.
                            </p>
                        </>
                },
                {
                    title: 'Fabric Vanes',
                    image: '/Assets/SubPagesImages/EtonBlindsImages/eton-blinds-fabric-vanes.webp',
                    description:
                        <>
                            <p>
                                <b>Full View</b> <br />
                                Slide the soft fabric vanes to one side or split from center to enjoy a clear outside view
                            </p>
                            <p>
                                <b>Day Time with Privacy</b> <br />
                                Open up the soft fabric vanes to the open position and enjoy subtle light diffusion with a view.
                            </p>
                            <p>
                                <b>Total Privacy</b> <br />
                                Rotate the vanes to close the blind fully for total privacy.
                            </p>
                        </>
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2221-300x167.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2222-300x167.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2223-300x167.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2224-300x167.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2225-300x167.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2226-300x167.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2227-300x167.webp'
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },


    "arcline-blinds": {
        id: "arcline-blinds",

        // Page Meta Fields
        META_PG_Title: 'Colby Blinds - designed to provide beauty and energy efficiency',
        META_PG_OG_Description: 'Colby / Honeycomb Blinds has unique light & privacy control combinations of light filtering & room darkening engineered for energy efficiency',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/colby-blinds`,
        OG_Title: 'Colby Blinds',

        name: "Arcline Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/ArclineBlindsImages/Arcline-01.webp',
                '/Assets/SubPagesImages/ArclineBlindsImages/Arcline-02.webp',
                '/Assets/SubPagesImages/ArclineBlindsImages/Arcline-03.jpg',
                '/Assets/SubPagesImages/ArclineBlindsImages/Arcline-04.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/ArclineBlindsImages/Inspiration-slider-01.jpg',
                '/Assets/SubPagesImages/ArclineBlindsImages/Inspiration-slider-02.jpg',
                '/Assets/SubPagesImages/ArclineBlindsImages/Inspiration-slider-03.jpg',
                '/Assets/SubPagesImages/ArclineBlindsImages/Inspiration-slider-04.jpg',
                '/Assets/SubPagesImages/ArclineBlindsImages/Inspiration-slider-05.jpg',
                '/Assets/SubPagesImages/ArclineBlindsImages/Inspiration-slider-06.jpg',
            ],
            text: [
                <>
                    <p>
                        <b>Callistus Arcline Blinds :</b>
                    </p>
                    <p>
                        Callistus Introducing Arcline Designer Blinds with custom-shaped bottoms which brings a distinctive and artistic flair to window treatments and transforming standard blinds into a design statement.
                    </p>
                    <p>
                        This Arcline Blinds enhances the visual impact of the blinds, making them not only functional but also a key element of interior decor.
                    </p>
                    <p>
                        The custom shaped bottom creates a unique profile that draws attention and complements contemporary design aesthetics.
                    </p>
                    <p>
                        In addition to their eye-catching design maintain all the practical benefits of the blinds standard and offers an excellent light control and privacy, with a wide range of fabric options, including light-filtering, blackout, and solar screen materials.
                    </p>
                    <p>
                        These blinds are also easy to operate, with choices for manual or motorized systems, and are available in a variety of colors and textures to suit any interior palette.
                    </p>
                    <p>
                        Arcline blinds provide a stylish and functional solution, allowing you to infuse your space with a personalized touch that reflects your unique taste and creativity
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        <b>Callistus Arcline Blinds :</b>
                    </p>
                    <p>
                        Callistus Introducing Arcline Designer Blinds with custom-shaped bottoms which brings a distinctive and artistic flair to window treatments and transforming standard blinds into a design statement.
                    </p>
                    <p>
                        This Arcline Blinds enhances the visual impact of the blinds, making them not only functional but also a key element of interior decor.
                    </p>
                    <p>
                        The custom shaped bottom creates a unique profile that draws attention and complements contemporary design aesthetics.
                    </p>
                    <p>
                        In addition to their eye-catching design maintain all the practical benefits of the blinds standard and offers an excellent light control and privacy, with a wide range of fabric options, including light-filtering, blackout, and solar screen materials.
                    </p>
                    <p>
                        These blinds are also easy to operate, with choices for manual or motorized systems, and are available in a variety of colors and textures to suit any interior palette.
                    </p>
                    <p>
                        Arcline blinds provide a stylish and functional solution, allowing you to infuse your space with a personalized touch that reflects your unique taste and creativity
                    </p>
                </>
            ],
            specs: [
                // { label: 'Orientation', value: 'Horizontal' },
                // { label: 'Visibility', value: 'Sheer, Translucent & Blackout' },
                // { label: 'Width (in mm)', value: '300 to 3000' },
                // { label: 'Drop (in mm)', value: '300 to 5000' }
            ],
            video: "https://www.youtube.com/embed/NaaSlWIVuHI?si=3vwjxCiVpnf1mmo1",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Arcline Blinds",
            systems: [
                {
                    title: 'Cord Control',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/cord-control-e1589892901632.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus Arcline Blinds is their ease of operation. A continuous cord is used to open and close the blinds without any hassles.
                        </>
                },
                {
                    title: 'Wand Control',
                    image: '/Assets/SubPagesImages/SierraBlindsImages/wand-control-e1589892259253.webp',
                    description:
                        <>
                            Arcline Blinds’ wand control system offers an easy and sleek solution for adjusting blinds with a simple pull of the wand. This manual mechanism allows for precise control over light and privacy, ensuring smooth and quiet operation. The durable design ensures long-lasting performance and effortless usability for any space.
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            Motorised Remote Control allows you to pre-set and easily operate Arcline blinds with just a press of a button.
                        </>
                }
            ]
        },
        solutions: {
            text: [

            ],
            combinations: [
                {
                    title: 'Customize your blinds',
                    image: '/Assets/SubPagesImages/ArclineBlindsImages/Solution-01.jpg',
                    description: 'Arcline Blinds offer endless customization – select from single or overlap options, 4, 5, or 6-way designs, and a wide variety of fabrics. Add your personal touch to create blinds that are as functional as they are beautiful.'
                },
                {
                    title: 'Tracks',
                    image: '/Assets/SubPagesImages/ArclineBlindsImages/Solution-02.jpg',
                    description: 'The Headrail in Arcline blinds is available in 3 different variants. You can choose from 3, 4, and 6 track channels as per your requirement.'
                },
                {
                    title: 'Channel Stacking Option',
                    image: '/Assets/SubPagesImages/ArclineBlindsImages/Solution-03.jpg',
                    description: 'You can modernize Arcline Blinds by using Plain Channel.'
                }
            ]
        },
        fabrics: {
            title: "",
            thumbnails: [
                '/Assets/SubPagesImages/ArclineBlindsImages/ArcPreview.webp'
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/colby-blinds/colby-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "blinds-with-curtain": {
        id: "blinds-with-curtain",

        // Page Meta Fields
        META_PG_Title: 'Curtains - the soft, elegant finishing touch for your windows',
        META_PG_OG_Description: 'Callistus Curtains combine flowing fabrics with functional tracks, giving your windows a soft, elegant, and luxurious finish.',
        META_PG_Canonical_OG_URL: `${process.env.REACT_APP_WEBSITE_URL}/products/blinds-with-curtain`,
        OG_Title: 'Curtains',

        name: "Curtains",
        heroSlider: {
            images: [
                '/Assets/SliderIamges/slide-7-curtains.webp',
                '/Assets/CategoryImages/3Curtain.webp',
                '/Assets/BlogPost_Images/curtain.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SliderIamges/slide-7-curtains.webp',
                '/Assets/CategoryImages/3Curtain.webp',
                '/Assets/BlogPost_Images/curtain.webp',
            ],
            text: [
                <>
                    <p>
                        <b>Callistus Curtains</b> bring warmth, softness, and elegance to any interior. Flowing fabrics drape beautifully across your windows, adding a luxurious finishing touch that blinds alone can't achieve.
                    </p>
                    <p>
                        Available in sheer, light-filtering, and blackout fabrics, our curtains let you choose exactly how much light and privacy you need — from airy sheers that soften daylight, to heavier drapes for a cosy, private feel at night.
                    </p>
                    <p>
                        Curtains pair beautifully with our blinds and track systems, letting you layer textures and colours for a truly custom look, whether it's a home, office, or hospitality space.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Callistus Curtains offer a soft, timeless way to dress your windows. Made from premium fabrics, they add texture, colour, and warmth to any room while giving you full control over light and privacy.
                    </p>
                    <p>
                        Choose from sheer, translucent, or blackout fabrics depending on your needs — sheers for a light, airy feel during the day, and blackout options for total privacy and darkness at night.
                    </p>
                    <p>
                        Our curtains work seamlessly with manual or motorized track systems, making them just as convenient as they are beautiful.
                    </p>
                </>
            ],
            specs: [
                { label: 'Fabric Types', value: 'Sheer, Translucent & Blackout' },
                { label: 'Operation', value: 'Manual & Motorized Tracks' },
                { label: 'Width (in mm)', value: 'Custom made to fit any window' },
            ],
            video: null,
            videoButton: null
        },
        operatingSystems: {
            title: "Available Operating Systems for Curtains",
            systems: [
                {
                    title: 'Manual Track',
                    image: '/Assets/AutomationImages/cutrain-track-2-1.webp',
                    description:
                        <>
                            A smooth, corded manual track lets you open and close your curtains with ease, giving reliable everyday performance at an affordable price.
                        </>
                },
                {
                    title: 'Motorized Track',
                    image: '/Assets/SpecialSolutions_Images/cutrain-track-2.webp',
                    description:
                        <>
                            <b>Callistus Motorized Curtain Tracks</b> let you open and close your curtains at the touch of a button, or automatically on a schedule — perfect for hard-to-reach or oversized windows.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                <>
                    <p>
                        Curtains add a soft, layered look that pairs beautifully with our blinds and track systems, letting you mix textures and colours for a completely custom finish in any space.
                    </p>
                </>
            ],
            combinations: []
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SliderIamges/curtain-fabric-sisal.jpg',
                '/Assets/SliderIamges/slide-7-curtains.webp',
                '/Assets/CategoryImages/3Curtain.webp',
                '/Assets/BlogPost_Images/curtain.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display curtains.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },
};